export default "__VITE_ASSET__B7kTVh3S__"